/**
 * Script này được nhúng vào theme.liquid để tự động kiểm tra giỏ hàng.
 * Mục đích: Kiểm tra tất cả các Free Gift đang có trong giỏ hàng. 
 * Nếu có discount được áp dụng (làm giảm final_line_price của sản phẩm), 
 * script sẽ sử dụng logic gốc của app TL Free Gift để đánh giá lại điều kiện.
 * Nếu không còn đủ điều kiện, script sẽ tự động xóa các Free Gift không hợp lệ.
 * 
 * Script này hoạt động linh hoạt (dynamic) cho toàn bộ dự án, không fix cứng ID hay giá trị nào.
 */

(function() {
    let isCheckingDiscounts = false;

    async function removeInvalidGiftsDueToDiscount() {
        if (isCheckingDiscounts) return;
        // Đảm bảo app gốc đã load xong
        if (!window.tlFreeGiftOffer || !window.tlFreeGiftOffer.itemsInCart || !window.tlFreeGiftOffer.rules) return;

        isCheckingDiscounts = true;

        try {
            // 1. Lấy dữ liệu giỏ hàng mới nhất
            const response = await fetch(window.Shopify.routes.root + 'cart.js');
            const cart = await response.json();

            let giftsToRemove = {};
            let cartModified = false;

            // 2. Lưu lại giá trị price gốc và tạm thời ghi đè bằng giá đã discount (final_line_price)
            const originalPrices = new Map();
            cart.items.forEach(item => {
                const itemInCart = window.tlFreeGiftOffer.itemsInCart.get(String(item.id)) || 
                                   window.tlFreeGiftOffer.itemsInCart.get(String(item.key));
                if (itemInCart) {
                    originalPrices.set(itemInCart, itemInCart.price);
                    // final_line_price trả về theo cents, chia cho 100 để đổi về giá trị chuẩn app đang dùng
                    const discountedPricePerItem = (item.final_line_price / item.quantity) / 100;
                    itemInCart.price = discountedPricePerItem;
                }
            });

            // 3. Đánh giá lại điều kiện của từng Free Gift trong giỏ hàng
            for (const item of cart.items) {
                // Kiểm tra xem item này có phải là quà tặng từ app không
                const ruleId = window.tlFreeGiftOffer.checkLineItemIsGift(item);
                if (ruleId) {
                    const rule = window.tlFreeGiftOffer.rules.find(r => String(r.id) === String(ruleId));
                    
                    if (rule) {
                        // Chạy lại logic kiểm tra điều kiện của app (lúc này itemsInCart đang mang giá đã discount)
                        const conditionResult = await window.tlFreeGiftOffer.checkRuleCondition(rule);
                        
                        // Nếu điều kiện không còn thỏa mãn (needToAdd = false) hoặc số lượng quà được nhận giảm đi
                        if (!conditionResult.needToAdd) {
                            giftsToRemove[item.key] = 0; // Set quantity = 0 để xóa
                            cartModified = true;
                        } else {
                            // Kiểm tra kĩ hơn: nếu quà này không còn nằm trong danh sách quà được thêm
                            const isStillValid = conditionResult.giftsToAdd.some(g => String(g.id) === String(item.id) || String(g.id) === String(item.variant_id));
                            if (!isStillValid) {
                                giftsToRemove[item.key] = 0;
                                cartModified = true;
                            }
                        }
                    }
                }
            }

            // 4. Khôi phục lại giá gốc cho itemsInCart để không làm hỏng logic của app
            originalPrices.forEach((price, itemInCart) => {
                itemInCart.price = price;
            });

            // 5. Cập nhật giỏ hàng nếu phát hiện quà không hợp lệ
            if (cartModified) {
                console.log("Free Gift App: Đang xóa quà không hợp lệ do có áp dụng discount làm giảm tổng tiền...");
                
                const updateRes = await fetch(window.Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ updates: giftsToRemove })
                });
                
                const newCart = await updateRes.json();
                
                // Kích hoạt event để refresh lại UI giỏ hàng
                window.dispatchEvent(new CustomEvent('cart:updated', { detail: newCart }));
                if (typeof window.tlFreeGiftOffer.updateCartData === 'function') {
                    window.tlFreeGiftOffer.updateCartData(); 
                }
            }
            
        } catch (error) {
            console.error("Free Gift App - Lỗi khi kiểm tra discount:", error);
        } finally {
            setTimeout(() => { isCheckingDiscounts = false; }, 1000);
        }
    }

    // Chạy khi trang đã load
    document.addEventListener('DOMContentLoaded', () => {
        setTimeout(removeInvalidGiftsDueToDiscount, 1000);
    });

    // Chạy mỗi khi có cập nhật giỏ hàng từ app
    window.addEventListener('TLFREEGIFT:update', () => {
        setTimeout(removeInvalidGiftsDueToDiscount, 500);
    });
    
    // Lắng nghe thêm các event của ajax cart phổ biến trên Shopify (để cover toàn bộ project)
    window.addEventListener('cart:updated', () => {
        setTimeout(removeInvalidGiftsDueToDiscount, 500);
    });
})();
